import { useContext, useEffect, useState } from 'react';

import { useStoreData } from '../';
import { ClientError } from '../../api';
import { ApiContext, CoreContext } from '../../providers';
import { addUserData, setError } from '../../state';
import { isEmptyObject } from '../../utils';
import { useRouter } from '../useRouter';

export const useScoreData = () => {
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { pathname } = useRouter();
    const { Upscore } = useContext(ApiContext);
    const { store, settings } = useContext(CoreContext);
    const { scoreData } = useStoreData().user;

    useEffect(() => {
        /**
         * We don't want scoreData to be loaded at all in `formue` project.
         */
        if (settings.languageVersion === 'formue') {
            setIsDataLoading(false);
            return;
        }

        if (scoreData || !isEmptyObject(scoreData)) {
            setIsDataLoading(false);
            return;
        }

        void (async () => {
            try {
                const data = await Upscore.getUserScoredata();
                store.dispatch(addUserData('scoreData', data.scoreData));
            } catch (error) {
                store.dispatch(setError('general'));
                throw new ClientError(error.message, {
                    category: 'Upscore API',
                    type: 'general',
                    error,
                });
            } finally {
                setIsDataLoading(false);
            }
        })();
    }, [pathname]);

    return { scoreData, isDataLoading };
};
